<template>
  <v-container>
    <BaseStepper
      v-if="isShowStepperBase"
      class="mb-1"
      :key="isQuestionSteps"
      :steps="isQuestionSteps ? questionSteps : applicationSteps"
    />
    <BaseAlert
      color="#FFF1E4"
      class="quote-expired-message mx-3 mx-xl-0"
      v-if="isExpired"
    >
      <div class="d-flex flex-no-wrap error-message">
        <div class="mr-3">
          <v-icon color="#fb8c00">mdi-alert</v-icon>
        </div>
        <div>
          <span class="font-weight-bold">Sorry!</span> This quote has expired.
          Please check all the details below are accurate and submit a new
          quote.
        </div>
      </div>
    </BaseAlert>
    <div class="mt-2 mx-3 mx-xl-0">
      <QuoteErrorAlert :isQuotationStage="isQuestionSteps" />
    </div>

    <div
      :class="'b2b-rent-protection-journey__container mb-10 white rounded-lg elevation-3 mx-3 mt-3 mx-xl-0'"
    >
      <router-view />
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import { EventBus } from "@/common/eventbus.js";
import { handleValidationError } from "@/common/utils";
import { ROUTE_NAME } from "@/constants/route.constants";
import { QUESTIONS_MODULE } from "@/store/types/module-types";

export default {
  name: "B2BRentProtectionLayout",
  components: {
    BaseStepper: () => import("@/components/BaseComponents/BaseStepper.vue"),
    BaseAlert: () => import("@/components/BaseComponents/BaseAlert.vue"),
    QuoteErrorAlert: () => import("@/components/QuoteErrorAlert.vue"),
  },
  data() {
    return {
      questionSteps: [
        {
          stepNumber: 1,
          label: "Your details",
          routeName: ROUTE_NAME.RENT_PROTECTION.B2B.YOUR_DETAILS,
        },
        {
          stepNumber: 2,
          label: "Cover details",
          routeName: ROUTE_NAME.RENT_PROTECTION.B2B.COVER_DETAILS,
        },
        {
          stepNumber: 3,
          label: "Your quote",
          routeName: ROUTE_NAME.RENT_PROTECTION.B2B.QUOTATION_RESULT,
        },
      ],
      applicationSteps: [
        {
          stepNumber: 4,
          label: this.$vuetify.breakpoint.lgAndUp
            ? "Your application"
            : "Application",
          routeName: ROUTE_NAME.RENT_PROTECTION.B2B.APPLICATION,
        },
        {
          stepNumber: 5,
          label: "Payment",
          routeName: ROUTE_NAME.RENT_PROTECTION.B2B.PAYMENT,
        },
        {
          stepNumber: 6,
          label: "Complete",
          routeName: ROUTE_NAME.RENT_PROTECTION.B2B.COMPLETE,
        },
      ],
    };
  },
  created() {
    // Listen for validation errors globally
    EventBus.$on("validation-error", handleValidationError);
  },
  computed: {
    ...mapGetters(QUESTIONS_MODULE, ["isExpired", "isQuestionSteps"]),
    currentRouteName() {
      return this.$route.name;
    },
    isShowStepperBase() {
      return ![ROUTE_NAME.RENT_PROTECTION.B2B.COMPLETE].includes(
        this.currentRouteName
      );
    },
  },
};
</script>

<style lang="scss">
.b2b-rent-protection-journey__container {
  padding: 24px 16px 40px 16px !important;
  .radio-group__wrapper {
    max-width: 400px;
  }
}

@media screen and (min-width: $grid-breakpoints-sm) {
  .b2b-rent-protection-journey__container {
    padding: 40px !important;
  }
}

@media screen and (min-width: $grid-breakpoints-lg) {
  .b2b-rent-protection-journey__container {
    padding: 40px 40px 80px 40px !important;
  }
  .quote-result__container,
  .b2b-rent-protection-journey__container {
    margin-bottom: 80px !important;
  }
}
</style>
